import { MasterDialog } from "#common/Dialog/Dialog"
import { useApiSend } from "#hooks/useApiSend"
import { Typography } from "@mui/material"
import { useContextBaja } from "Components/bajas/contexts/contexts"
import { bajaDelete } from "Components/bajas/services/api"
import { useCallback, useMemo, useState } from "react"

export default function BajaCancelDialog({ baja, open, setOpen, closeDialog }) {
	const { refresh, setBaja } = useContextBaja()
	const [disabled, setDisabled] = useState(false)

	const success = () => {
		setOpen(false)
		setBaja(null)
		closeDialog()
		refresh()

	}
	const end = () => {
		setDisabled(false)
	}
	const { fetch } = useApiSend(bajaDelete, { success, end })

	const handleSend = useCallback(() => {
		setDisabled(true)
		fetch(baja?.id)
	}, [baja?.id, fetch, setDisabled])

	const buttons = useMemo(
		() => [
			{
				label: "Cancelar",
				onClick: () => setOpen(false),
				disabled,
			},
			{
				label: "Aceptar",
				onClick: () => handleSend(),
				disabled,
			},
		],
		[disabled, handleSend, setOpen]
	)

	return (
		<MasterDialog {...{ open, setOpen, buttons }} title={"Cancelar baja"} maxWidth={"sm"}>
			<Typography textAlign="center" variant="h6" fontWeight="bold">
				¿Desea cancelar la baja de {baja?.name_collaborator}?
			</Typography>
			<Typography textAlign="center">
				Una vez confirmada, no podrá revertir esta acción ni realizar modificaciones
				posteriores.
			</Typography>
		</MasterDialog>
	)
}
